import axios from "../../../axios";

const getMessageQuota = async () => {
  try {
    const { data } = await axios.get(`/messages/quota`);
    return data;
  } catch (e) {
    return null;
  }
};

export { getMessageQuota };